import {
    DevicesFotaIcon,
    GroupOutlineIcon
} from "@dotnet/telematics-design-system";

import { ROUTES } from "shared";

import {
    FIND_TOOL_TAB_LABELS,
    FIND_TOOL_TAB_VALUES,
    SEARCH_VALUES
} from "../types";

export const FIND_TOOL_TABS = [
    {
        label: FIND_TOOL_TAB_LABELS.Device,
        value: FIND_TOOL_TAB_VALUES.Device,
        resourceRoute: ROUTES.Devices,
        listValue: SEARCH_VALUES.Imei,
        icon: DevicesFotaIcon
    },
    {
        label: FIND_TOOL_TAB_LABELS.User,
        value: FIND_TOOL_TAB_VALUES.User,
        resourceRoute: ROUTES.Users,
        listValue: SEARCH_VALUES.Email,
        icon: GroupOutlineIcon
    }
];
